export default function CheckCircleIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.85 12a8.15 8.15 0 0110.697-7.744.85.85 0 10.53-1.615A9.841 9.841 0 0012 2.15c-5.44 0-9.85 4.41-9.85 9.85 0 5.44 4.41 9.85 9.85 9.85 5.44 0 9.85-4.41 9.85-9.85a.85.85 0 00-1.7 0 8.15 8.15 0 01-16.3 0zm15.752-4.4a.85.85 0 10-1.204-1.2l-6.348 6.376-2.43-2.598a.85.85 0 10-1.241 1.16l3.03 3.242a.85.85 0 001.223.02l6.97-7z"
        clipRule="evenodd"
      />
    </svg>
  );
}
